// extracted by mini-css-extract-plugin
export var action = "fc-video-page-module--action--a7452";
export var active = "fc-video-page-module--active--da7c3";
export var caption = "fc-video-page-module--caption--922c6";
export var cover = "fc-video-page-module--cover--151d1";
export var inner = "fc-video-page-module--inner--0579c";
export var player = "fc-video-page-module--player--1eb87";
export var root = "fc-video-page-module--root--d9da8";
export var video = "fc-video-page-module--video--20a25";